import { createIcon } from "@chakra-ui/react";
import React from "react";

const IconCss = createIcon({
  displayName: "IconCss",
  viewBox: "0 0 538.584 538.583",
  path: (
    <>
      <path d="M0 0h538.584v538.583H0V0z" fill="none" />
      <path
        d="M405.5 467.454L269.29 504.13l-136.212-36.676-31.432-340.525h335.29L405.5 467.454z"
        fill="#2062af"
      />
      <path
        d="M269.289 154.511v320.367l.308.084 110.229-29.682 25.443-290.769h-135.98z"
        fill="#3c9cd7"
      />
      <path d="M191.985 76.899V56.631h29.571V34.453h-51.749v62.684h51.749V76.899h-29.571zm82.766-20.268h20.674V34.453h-51.754v22.178c6.924 6.924 10.535 10.238 20.549 20.252-5.854 0-20.549.021-20.549.02v20.234h51.754V76.899l-20.674-20.268zm73.352 0h20.673V34.453H317.02v22.178c6.924 6.924 10.537 10.238 20.551 20.252-5.852 0-20.551.021-20.551.02v20.234h51.757V76.899l-20.674-20.268z" />
      <path
        d="M269.168 239.656l-97.49 40.602 3.233 40.199 94.257-40.301 100.265-42.868 4.157-41.122-104.422 43.49z"
        fill="#fff"
      />
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="-825.508"
        y1="1338.301"
        x2="-825.508"
        y2="1419.102"
        gradientTransform="matrix(1 0 0 -1 1045.93 1658.759)"
      >
        <stop offset=".387" stopColor="#d1d3d4" stopOpacity="0" />
        <stop offset="1" stopColor="#d1d3d4" />
      </linearGradient>
      <path
        d="M171.677 280.258l3.233 40.199 94.257-40.301v-40.5l-97.49 40.602z"
        fill="url(#a)"
      />
      <linearGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        x1="-724.552"
        y1="1378.602"
        x2="-724.552"
        y2="1462.591"
        gradientTransform="matrix(1 0 0 -1 1045.93 1658.759)"
      >
        <stop offset=".387" stopColor="#d1d3d4" stopOpacity="0" />
        <stop offset="1" stopColor="#d1d3d4" />
      </linearGradient>
      <path
        d="M373.59 196.167l-104.422 43.489v40.5l100.265-42.868 4.157-41.121z"
        fill="url(#b)"
      />
      <linearGradient
        id="c"
        gradientUnits="userSpaceOnUse"
        x1="-874.103"
        y1="1302.263"
        x2="-680.039"
        y2="1302.263"
        gradientTransform="matrix(1 0 0 -1 1045.93 1658.759)"
      >
        <stop offset="0" stopColor="#e8e7e5" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <path
        d="M171.827 280.258l3.234 40.199 144.625.461-3.235 53.598-47.59 13.398-45.748-11.551-2.772-33.268h-42.508l5.545 64.225 85.945 25.412 85.479-24.951 11.09-127.523H171.827z"
        fill="url(#c)"
      />
      <path
        d="M269.168 280.258h-97.49l3.233 40.199 94.257.301v-40.5zm0 107.528l-.462.129-45.742-11.551-2.772-33.268h-42.507l5.544 64.225 85.939 25.412v-44.947z"
        opacity=".05"
      />
      <linearGradient
        id="d"
        gradientUnits="userSpaceOnUse"
        x1="-883.032"
        y1="1442.031"
        x2="-672.341"
        y2="1442.031"
        gradientTransform="matrix(1 0 0 -1 1045.93 1658.759)"
      >
        <stop offset="0" stopColor="#e8e7e5" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <path
        d="M162.898 196.167H373.59l-4.157 41.122H167.98l-5.082-41.122z"
        fill="url(#d)"
      />
      <path
        d="M269.168 196.167h-106.27l5.082 41.122h101.188v-41.122z"
        opacity=".05"
      />
    </>
  ),
});

export default IconCss;
